import { render, staticRenderFns } from "./no-goods.vue?vue&type=template&id=9e8d6936&scoped=true&"
import script from "./no-goods.vue?vue&type=script&lang=js&"
export * from "./no-goods.vue?vue&type=script&lang=js&"
import style0 from "./no-goods.vue?vue&type=style&index=0&id=9e8d6936&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e8d6936",
  null
  
)

export default component.exports